import { jsx } from "@emotion/react/jsx-runtime";
import { Alert as Alert$1 } from "@mui/material";
import { AlertTriangle, Info, CheckCircle, AlertCircle, X } from "react-feather";
import { alertStyles } from "./Alert.styles.js";
const iconMap = {
  error: /* @__PURE__ */ jsx(AlertTriangle, {}),
  info: /* @__PURE__ */ jsx(Info, {}),
  success: /* @__PURE__ */ jsx(CheckCircle, {}),
  warning: /* @__PURE__ */ jsx(AlertCircle, {})
};
const slots = {
  closeIcon: X
};
const Alert = ({
  ...props
}) => {
  return /* @__PURE__ */ jsx(Alert$1, { css: alertStyles, iconMapping: iconMap, slots, ...props });
};
export {
  Alert
};
//# sourceMappingURL=Alert.js.map
